<template>
  <div class="text-truncate" :title="object[columnKey]">
    {{ object[columnKey] }}
  </div>
</template>

<script>
export default {
  name: "StringTruncated",
  props: ["object", "columnKey"],
};
</script>
